module.exports = __webpack_public_path__ + "greatist-1481905b.png";